export const load = () => ({
	title: 'How to Soundproof a Room for Music',
	showTitle: true,
});
